import { render, staticRenderFns } from "./moudleVersion__list.vue?vue&type=template&id=58d16983"
import script from "./moudleVersion__list.vue?vue&type=script&lang=js"
export * from "./moudleVersion__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports